module.exports = __webpack_public_path__ + "media/images/icons/bank-168b8df7601e1a9311afe98ebf859b58.svg";